/**
 * @author Srijan Shakya
 * @description https://marvelapp.com/4g4b5dg/screen/61020234
 */

import React from 'react';
import { connect } from 'react-redux';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import originalMoment from 'moment';
import { extendMoment } from 'moment-range';
import DatePicker from '@components/@core/DatePicker';
import ErrorBoundary from '@components/@core/ErrorBoundary';
import Filter from '@components/@core/Filter';
import EditDropdown from '@components/EditDropdown';
import AppActions from '~/actions/app';
import ManageActions from '~/actions/manage';
import withNavigate from '~/hocs/withNavigate';
import { QuotaReportTabs, IndividualQuotaReportMenu } from '~/services/config';
import Report from './Report';

const moment = extendMoment(originalMoment);

class IndividualQuota extends React.Component {
    state = {
        dateStart: moment().subtract(11, 'months').startOf('month').format('YYYY-MM-DD'),
        dateEnd: moment().endOf('month').format('YYYY-MM-DD'),
        activeTab: 'scorecard',
        page: 1,
        perPage: 10,
        userId: Number(this.props.params?.id || 0),
    };

    handleTab = (activeTab) => {
        const { dateStart, dateEnd, page, perPage, userId } = this.state;
        const payload = {
            userId,
            dateStart,
            dateEnd,
            activeTab,
            page,
            perPage,
        };
        this.props.getIndividualReport(payload);
        this.setState({ activeTab });
    };

    handleDate = (e) => {
        const { activeTab, page, perPage, userId } = this.state;
        const dateStart = moment(e.start).format('YYYY-MM-DD');
        const dateEnd = moment(e.end).format('YYYY-MM-DD');
        const payload = {
            userId,
            dateStart,
            dateEnd,
            fliter: activeTab,
            page,
            perPage,
        };
        this.props.getIndividualReport(payload);
        this.setState({ dateStart, dateEnd });
    };

    handlePagination = (page, perPage) => {
        const { dateStart, dateEnd, userId, activeTab } = this.state;

        if (perPage > 50) {
            page = 1;
        }
        const payload = {
            userId,
            dateStart,
            dateEnd,
            fliter: activeTab,
            page,
            perPage,
        };
        this.props.getIndividualReport(payload);
        this.setState({ page, perPage });
    };

    handleSelectMenu = (e) => {
        switch (e) {
            case 'edit actuals':
                break;

            case 'edit program assignment':
                break;

            case 'edit scorecard assignment':
                break;

            case 'view scorecards':
                break;

            case 'view programs':
                break;

            default:
                break;
        }
    };

    render() {
        const { individualQuotaReport, userRole } = this.props;
        const { activeTab, dateStart, dateEnd } = this.state;
        const date = moment.range(dateStart, dateEnd);
        const tabMenu = QuotaReportTabs.filter((tab) => tab.name !== 'all');

        return (
            <ErrorBoundary className="individaul-quota-reports">
                <Filter back="all quotas" />
                <div className="card">
                    <div className="d-flex justify-content-between mb-2 mt-4 align-items-center">
                        <span className="dsl-b22 bold">Employees Quotas</span>
                        <EditDropdown options={IndividualQuotaReportMenu[userRole]} onChange={this.handleSelectMenu(individualQuotaReport)} />
                    </div>
                    <div className="d-flex align-self-end">
                        <DatePicker calendar="range" append="caret" format="MMM YYYY" as="span" align="right" value={date} onSelect={this.handleDate} />
                    </div>
                    <Tabs defaultActiveKey="scorecard" activeKey={activeTab} id="records" onSelect={this.handleTab} className="py-3 py-md-4 d-none d-md-flex">
                        {tabMenu.map((tab) => (
                            <Tab key={tab.name} eventKey={tab.name} title={tab.label}>
                                <Report data={individualQuotaReport} dateStart={dateStart} dateEnd={dateEnd} onPage={this.handlePagination} />
                            </Tab>
                        ))}
                    </Tabs>
                </div>
            </ErrorBoundary>
        );
    }
}

const mapStateToProps = (state) => ({
    userId: state.app.id,
    userRole: state.app.app_role_id,
    individualQuotaReport: state.manage.individualQuotaReport,
});

const mapDispatchToProps = (dispatch) => ({
    getIndividualReport: (payload, route) => dispatch(ManageActions.postindividualquotareportRequest(payload, null)),
    toggleModal: (e) => dispatch(AppActions.modalRequest(e)),
});

const IndividualQuotaWithNavigate = withNavigate(IndividualQuota);
export default connect(mapStateToProps, mapDispatchToProps)(IndividualQuotaWithNavigate);
